export const announcementRoutes = {
  announcements: () => '/announcements',
  operationsWithAnnouncement: (announcementId: string) => `/announcements/${announcementId}`,
};
